import { css } from "lit";

export const communicationPreferencesStyles = css`
  :host {
    display: block;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .communication-preferences {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    padding: var(--sds-size-space-800) 0;
    overflow: hidden;
    height: 100%;
  }

  .description {
    color: var(--sds-color-text-default-secondary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%;
    margin: 0;
  }

  .creator-list {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    padding-bottom: var(--sds-size-space-800);
  }

  .creator-row {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    padding: var(--sds-size-space-400) var(--sds-size-space-600);
    border-radius: var(--sds-size-radius-600);
    background: var(--sds-color-background-default-secondary);
  }

  .creator-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    background: var(--sds-color-background-default-tertiary);
  }

  .creator-handle {
    flex: 1;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  wow-switch {
    --wow-switch-border-top: none;
    --wow-switch-padding: 0;
    width: auto;
  }

  .empty-state {
    color: var(--sds-color-text-default-secondary);
    text-align: center;
    padding: var(--sds-size-space-1200) 0;
  }

  .loading {
    text-align: center;
    padding: var(--sds-size-space-1200) 0;
    color: var(--sds-color-text-default-secondary);
  }
`;
